import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const BADGE = { APPROVED: "bg-emerald-100 text-emerald-800", PENDING: "bg-amber-100 text-amber-900", CHANGED: "bg-rose-100 text-rose-800" };
const LABEL = { APPROVED: "Approved", PENDING: "Awaiting review", CHANGED: "Text changed, re-review" };

/** Native-speaker review gate for the re-deployment translations (admins approve / withdraw; name + time recorded). */
export function RedeployReviewList({ langs, onChange, onPick }) {
  const { user } = useAuth() || {};
  const admin = ["admin", "super_admin", "management"].includes(user?.role);
  const rows = langs.filter((l) => l.review && l.review.status !== "SOURCE");
  const act = async (l, approve) => {
    let reviewer_name = null;
    if (approve) {
      reviewer_name = window.prompt(`Approve the ${l.name} re-deployment text for real labels.\nName of the native speaker who checked it (optional):`, "");
      if (reviewer_name === null) return;
    } else if (!window.confirm(`Withdraw approval for ${l.name}? Real labels go back to English for this language.`)) return;
    try { await api.post(`/welcome-label/redeploy-translations/${l.language}/review`, { approve, reviewer_name }); toast.success(`${l.name} ${approve ? "approved" : "approval withdrawn"}`); onChange(); }
    catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };
  if (!rows.length) return null;
  return (
    <div className="rounded-lg border border-slate-200" data-testid="redeploy-review-list">
      <div className="border-b border-slate-200 px-3 py-2 text-xs font-semibold text-slate-700">Native-speaker review ({rows.filter((l) => l.review.status === "APPROVED").length} / {rows.length} approved)</div>
      <ul className="max-h-56 divide-y divide-slate-100 overflow-y-auto">
        {rows.map((l) => (
          <li key={l.code} className="flex items-center gap-2 px-3 py-1.5 text-xs" data-testid={`redeploy-review-${l.language}`}>
            <button className="min-w-0 flex-1 truncate text-left text-slate-800 hover:underline" onClick={() => onPick(l.code)} data-testid={`redeploy-review-pick-${l.language}`}>{l.name} <span className="text-slate-500">{l.native}</span></button>
            <span className={`rounded px-1.5 py-0.5 text-[10px] font-semibold ${BADGE[l.review.status]}`} title={l.review.by ? `${l.review.by}${l.review.reviewer_name ? ` · reviewer ${l.review.reviewer_name}` : ""} · ${String(l.review.at).slice(0, 16).replace("T", " ")} UTC` : ""} data-testid={`redeploy-review-status-${l.language}`}>{LABEL[l.review.status]}</span>
            {admin && (l.review.status === "APPROVED"
              ? <button className="rounded border border-slate-300 px-2 py-0.5 text-[10px] font-semibold text-slate-700 hover:bg-slate-100" onClick={() => act(l, false)} data-testid={`redeploy-review-withdraw-${l.language}`}>Withdraw</button>
              : <button className="rounded border border-emerald-600 px-2 py-0.5 text-[10px] font-semibold text-emerald-800 hover:bg-emerald-50" onClick={() => act(l, true)} data-testid={`redeploy-review-approve-${l.language}`}>Approve</button>)}
          </li>
        ))}
      </ul>
    </div>
  );
}
